import { createContext, useContext } from 'react';
import type { PaletteMode } from '@mui/material';

export interface ThemeModeValue {
  mode: PaletteMode;
  toggleMode: () => void;
}

export const ThemeModeContext = createContext<ThemeModeValue | null>(null);

export function useThemeMode() {
  const value = useContext(ThemeModeContext);
  if (!value) throw new Error('useThemeMode must be used inside ArchiveThemeProvider');
  return value;
}
